import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { Mgt1Service } from 'src/app/services/mgt1.service';
import { PaymentofdividentService } from 'src/app/services/paymentofdivident.service';
import { AlertComponent } from 'src/app/structure/alert/alert.component';

@Component({
  selector: 'app-paymentof-divident',
  templateUrl: './paymentof-divident.component.html',
  styleUrls: ['./paymentof-divident.component.css']
})
export class PaymentofDividentComponent implements OnInit {

  podForm: FormGroup;
  podList: any = [];
  editPaymentData: any = [];
  DateOfBookClosureModel: any;
  recordDateModel: any;
  DateOfDeclarationModel: any;
  DateOfDueModel: any;
  DateOfTransferModel: any;
  DateOfPaymentModel: any;
  editPaymentID: any = [];
  addBtn: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnclick: boolean;
  nameOfMemberList: any[];
  certificateNoList: any[];
  registerList: any[];
  distinctiveFromList: any[];
  distinctiveToList: any[];
  folioNoDematAcNoList: any[];
  totalNoOfSharesHeld: any[];
  classofSharesList: any[];
  dateOfIssueList: any[];
  noOfSharesAllotedList: any[];
  Mgt1List:any[];
  proxydata: any[];

  constructor(private PaymentOfDividendService: PaymentofdividentService, private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction, private alert: AlertComponent, private router: Router, private customValidation: CustomValidation,private mgt1Service: Mgt1Service
  ) { }

  ngOnInit() {
    this.podForm = new FormGroup({
      percentageOfDividendDeclared: new FormControl('', []),
      dividendRate: new FormControl('', []),
      dateOfBookClosure: new FormControl('', []),
      recordDate: new FormControl('', []),
      dateOfDeclaration: new FormControl('', []),
      dateOfDue: new FormControl('', []),
      dateOfTransfer: new FormControl('', []),
      nameOfMembers: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z' ]*$"), this.customValidation.noWhitespaceValidator]),
      regdAddress: new FormControl('', []),
      folioNo: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), this.customValidation.noWhitespaceValidator]),
      sharesheld: new FormControl('', []),
      bankaccountnumber: new FormControl('', [Validators.minLength(8), Validators.maxLength(20)]),
      bankAddress: new FormControl('', []),
      amountPaid: new FormControl('', []),
      dividendAmount: new FormControl('', []),
      dividendWarrantFrom: new FormControl('', []),
      dividendWarrantTo: new FormControl('', []),
      // serialNumberofWarrant: new FormControl('', []),
      dateOfPayment: new FormControl('', []),
      modeOfPayment: new FormControl('', []),
      intermDividend: new FormControl('', []),
      finalDividend: new FormControl('', []),
      dividendAbeyance: new FormControl('', []),
      // dividendPayable: new FormControl('', []),
      nameOfNominee: new FormControl('', [Validators.pattern("^[a-zA-Z][a-zA-Z ]*$")]),
      legalHeir: new FormControl('', []),
      remarks1: new FormControl('', []),
    })

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = false;
        this.editPaymentID = params['particularId'];
        this.getPaymentById(this.editPaymentID);
      } else {
        this.addBtn = true;
      }
    })
    this.getRegisterMgt1List();

  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['paymentOfDividendList']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  getRegisterMgt1List() {
  
    this.nameOfMemberList =[];
    this.folioNoDematAcNoList =[];
    this.totalNoOfSharesHeld =[];
    this.Mgt1List = [];

    this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
      this.Mgt1List.push(MgtList.data);
      for(let i=0; i< MgtList.data.length; i++){
        if(MgtList.data[i].personalDetails.nameOfMember !=""){
         // console.log("************************check8****", this.nameOfMemberList.push({MGT1_id:MgtList.data[i].personalDetails._id,nameOfMember:MgtList.data[i].personalDetails.nameOfMember}))
         // console.log("************************check87****", this.nameOfMemberList.push({MGT1_id:MgtList.data[i]._id,nameOfMember:MgtList.data[i].personalDetails.nameOfMember}))
        this.nameOfMemberList.push({MGT1_id:MgtList.data[i].personalDetails._id,nameOfMember:MgtList.data[i].personalDetails.nameOfMember});
        }
       // this.podForm.controls.MGT1Id =  MgtList.data[i]._id;
    }
    this.totalNoOfSharesHeld=MgtList.data;
    this.folioNoDematAcNoList = MgtList.data;
    this.classofSharesList = MgtList.data;
   // this.podForm.controls.MGT1Id =  MgtList.data[0]._id;
     
    });
  }

  getsh2FormDetails(ev,value){
    //var id = ev.target.value;
    
    //console.log("************ev.target.attributes.id;**********1*************ev.target.value",ev.target.getAttribute('data-mgt1id'));
   // console.log("************ev.target.attributes.id;**********1*************ev.target.value",ev.target.options[ev.target.selectedIndex].getAttribute('data-mgt1id'));
   
   this.Mgt1List.forEach(element => {
     console.log("***********************************element",element);
 
    // element.detailsOfHoldings.forEach(item => {
     for(let i=0; i<element.length; i++){
       if(element[i].personalDetails.nameOfMember == value){
         console.log("************************match************",element[i].personalDetails.nameOfMember == value)
        // this.sh2Form.controls.namePersonRenewedDuplicateCertiisIssued.setValue(element.personalDetails.nameOfMember);
        this.podForm.controls.folioNo.setValue(element[i].folioNoDematAcNo);
        this.podForm.controls.sharesheld.setValue(element[i].totalNoOfSharesHeld);
        this.podForm.controls.regdAddress.setValue(element[i].personalDetails.address);
        this.podForm.controls.MGT1Id =  element[i]._id;
       }
     }
    // })
   });
 } 
  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  showFormEntry() {
    this.disabledOnclick = true;
    var object = {

      percentageOfDividendDeclared: this.podForm.controls.percentageOfDividendDeclared.value,
      dividendRate: this.podForm.controls.dividendRate.value,
      dateOfBookClosure: this.setDate(this.podForm.controls.dateOfBookClosure.value),
      recordDate: this.setDate(this.podForm.controls.recordDate.value),
      dateOfDeclaration: this.setDate(this.podForm.controls.dateOfDeclaration.value),
      dateOfDue: this.setDate(this.podForm.controls.dateOfDue.value),
      dateOfTransfer: this.setDate(this.podForm.controls.dateOfTransfer.value),
      nameOfMembers: this.podForm.controls.nameOfMembers.value,
      regdAddress: this.podForm.controls.regdAddress.value,
      folioNo: this.podForm.controls.folioNo.value,
      sharesheld: this.podForm.controls.sharesheld.value,
      accountNumber: this.podForm.controls.bankaccountnumber.value,
      bankAddress: this.podForm.controls.bankAddress.value,
      amountPaid: this.podForm.controls.amountPaid.value,
      dividendAmount: this.podForm.controls.dividendAmount.value,
      dividendWarrantFrom: this.podForm.controls.dividendWarrantFrom.value,
      dividendWarrantTo: this.podForm.controls.dividendWarrantTo.value,
      // serialNumberofWarrant: this.podForm.controls.serialNumberofWarrant.value,
      dateOfPayment: this.setDate(this.podForm.controls.dateOfPayment.value),
      modeOfPayment: this.podForm.controls.modeOfPayment.value,
      intermDividend: this.podForm.controls.intermDividend.value,
      finalDividend: this.podForm.controls.finalDividend.value,
      dividendAbeyance: this.podForm.controls.dividendAbeyance.value,
      // dividendPayable: this.podForm.controls.dividendPayable.value,
      nameOfNominee: this.podForm.controls.nameOfNominee.value,
      legalHeir: this.podForm.controls.legalHeir.value,
      remarks1: this.podForm.controls.remarks1.value,
      mgt1Id:this.podForm.controls.MGT1Id

    }
    this.PaymentOfDividendService.samplePodRecord(object).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {
    
        this.alert.successWithOk(response.message, 'paymentOfDividendList');
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
        this.alert.error(response.message);
        }
      }
    })   //connection between FE and BE

  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  getPaymentById(paymentId) {
    this.PaymentOfDividendService.updatePayment(paymentId).subscribe(response => {
      this.editPaymentData = response.data[0];
      console.log(" this.editPaymentData", this.editPaymentData);
   
      this.mgt1Service.getMgtList({ search: false }).subscribe(MgtList => {
         this.Mgt1List.push(MgtList.data);
        MgtList.data.forEach(element => {
           
          console.log("__________ this.element", element._id == this.editPaymentData.mgt1Id);
          if( element._id == this.editPaymentData.mgt1Id){
         
          this.podForm.controls.nameOfMembers.setValue(element.personalDetails.nameOfMember);
          this.podForm.controls.regdAddress.setValue(element.personalDetails.address);
          this.podForm.controls.folioNo.setValue(element.folioNoDematAcNo);
          this.podForm.controls.sharesheld.setValue(element.totalNoOfSharesHeld);
        return false ;
        }
        })
      });
      this.podForm.controls.percentageOfDividendDeclared.setValue(this.editPaymentData.percentageOfDividendDeclared);
      this.podForm.controls.dividendRate.setValue(this.editPaymentData.dividendRate);
      this.podForm.controls.dateOfBookClosure.setValue(this.editPaymentData.dateOfBookClosure);
      this.podForm.controls.recordDate.setValue(this.editPaymentData.recordDate);
      this.podForm.controls.dateOfDeclaration.setValue(this.editPaymentData.dateOfDeclaration);
      this.podForm.controls.dateOfDue.setValue(this.editPaymentData.dateOfDue);
      this.podForm.controls.dateOfTransfer.setValue(this.editPaymentData.dateOfTransfer);
     // this.podForm.controls.nameOfMembers.setValue(this.editPaymentData.nameOfMembers);
     // this.podForm.controls.regdAddress.setValue(this.editPaymentData.regdAddress);
     // this.podForm.controls.folioNo.setValue(this.editPaymentData.folioNo);
     // this.podForm.controls.sharesheld.setValue(this.editPaymentData.sharesheld);
      this.podForm.controls.bankaccountnumber.setValue(this.editPaymentData.accountNumber);
      this.podForm.controls.bankAddress.setValue(this.editPaymentData.bankAddress);
      this.podForm.controls.amountPaid.setValue(this.editPaymentData.amountPaid);
      this.podForm.controls.dividendAmount.setValue(this.editPaymentData.dividendAmount);
      this.podForm.controls.dividendWarrantFrom.setValue(this.editPaymentData.dividendWarrantFrom);
      this.podForm.controls.dividendWarrantTo.setValue(this.editPaymentData.dividendWarrantTo);
      // this.podForm.controls.serialNumberofWarrant.setValue(this.editPaymentData.serialNumberofWarrant);
      this.podForm.controls.dateOfPayment.setValue(this.editPaymentData.dateOfPayment);
      this.podForm.controls.modeOfPayment.setValue(this.editPaymentData.modeOfPayment);
      this.podForm.controls.intermDividend.setValue(this.editPaymentData.intermDividend);
      this.podForm.controls.finalDividend.setValue(this.editPaymentData.finalDividend);
      this.podForm.controls.dividendAbeyance.setValue(this.editPaymentData.dividendAbeyance);
      // this.podForm.controls.dividendPayable.setValue(this.editPaymentData.dividendPayable);
      this.podForm.controls.nameOfNominee.setValue(this.editPaymentData.nameOfNominee);
      this.podForm.controls.legalHeir.setValue(this.editPaymentData.legalHeir);
      this.podForm.controls.remarks1.setValue(this.editPaymentData.remarks1);
      if (this.editPaymentData.dateOfBookClosure != null) {
        let dt = new Date(this.setFormatDate(this.editPaymentData.dateOfBookClosure));
        this.DateOfBookClosureModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editPaymentData.recordDate != null) {
        let dt = new Date(this.setFormatDate(this.editPaymentData.recordDate));
        this.recordDateModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editPaymentData.dateOfDeclaration != null) {
        let dt = new Date(this.setFormatDate(this.editPaymentData.dateOfDeclaration));
        this.DateOfDeclarationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editPaymentData.dateOfDue != null) {
        let dt = new Date(this.setFormatDate(this.editPaymentData.dateOfDue));
        this.DateOfDueModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editPaymentData.dateOfTransfer != null) {
        let dt = new Date(this.setFormatDate(this.editPaymentData.dateOfTransfer));
        this.DateOfTransferModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editPaymentData.dateOfPayment != null) {
        let dt = new Date(this.setFormatDate(this.editPaymentData.dateOfPayment));
        this.DateOfPaymentModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    })
  }

  updateBankAccountParticulars(_id) {
    this.disabledOnclick = true;
    var object = {
      percentageOfDividendDeclared: this.podForm.controls.percentageOfDividendDeclared.value,
      dividendRate: this.podForm.controls.dividendRate.value,
      dateOfBookClosure: this.setDate(this.podForm.controls.dateOfBookClosure.value),
      recordDate: this.setDate(this.podForm.controls.recordDate.value),
      dateOfDeclaration: this.setDate(this.podForm.controls.dateOfDeclaration.value),
      dateOfDue: this.setDate(this.podForm.controls.dateOfDue.value),
      dateOfTransfer: this.setDate(this.podForm.controls.dateOfTransfer.value),
      nameOfMembers: this.podForm.controls.nameOfMembers.value,
      regdAddress: this.podForm.controls.regdAddress.value,
      folioNo: this.podForm.controls.folioNo.value,
      sharesheld: this.podForm.controls.sharesheld.value,
      accountNumber: this.podForm.controls.bankaccountnumber.value,
      bankAddress: this.podForm.controls.bankAddress.value,
      amountPaid: this.podForm.controls.amountPaid.value,
      dividendAmount: this.podForm.controls.dividendAmount.value,
      dividendWarrantFrom: this.podForm.controls.dividendWarrantFrom.value,
      dividendWarrantTo: this.podForm.controls.dividendWarrantTo.value,
      // serialNumberofWarrant: this.podForm.controls.serialNumberofWarrant.value,
      dateOfPayment: this.setDate(this.podForm.controls.dateOfPayment.value),
      modeOfPayment: this.podForm.controls.modeOfPayment.value,
      intermDividend: this.podForm.controls.intermDividend.value,
      finalDividend: this.podForm.controls.finalDividend.value,
      dividendAbeyance: this.podForm.controls.dividendAbeyance.value,
      // dividendPayable: this.podForm.controls.dividendPayable.value,
      nameOfNominee: this.podForm.controls.nameOfNominee.value,
      legalHeir: this.podForm.controls.legalHeir.value,
      remarks1: this.podForm.controls.remarks1.value,
      mgt1Id:this.podForm.controls.MGT1Id
      
    }
    this.PaymentOfDividendService.updateBankAccountParticulars(object, this.editPaymentID).subscribe(response => {
      this.disabledOnclick = false;
      if (response.status == 0) {

        this.alert.successWithOk(response.message, 'paymentOfDividendList');
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
        this.alert.error(response.message);
        }
      }

    })
  }
  generateOutput() {
    var object = {
      id: this.editPaymentID,
      fromDate: null,
      toDate: null
    }
    this.PaymentOfDividendService.generatePaymentOfDividendDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editPaymentID);
          setTimeout(function () {
            self.downloadPdfDocument(self.editPaymentID);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.PaymentOfDividendService.downloadPaymentOfDividendFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.PaymentOfDividendService.downloadPaymentOfDividendPdfFile(id, 'Single');
  }



}
